import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialBasicModule } from './modules/ui/material-basic.module';
import { MaterialLayoutModule } from './modules/ui/material-layout.module';
import { UnderConstructionComponent } from './shared/components/under-construction/under-construction.component';
import { AboutComponent } from './pages/about/about.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { HomeComponent } from './pages/home/home.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { TranslatingPageComponent } from './shared/components/translating-page/translating-page.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialFormsModule } from './modules/ui/material-forms.module';
import { HttpClientModule } from '@angular/common/http';
import { SummaryComponent } from './pages/summary/summary.component';
import { MatCarouselModule } from '@ngmodule/material-carousel';
import { WhereComponent } from './pages/where/where.component';
import { ContactsComponent } from './pages/contacts/contacts.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { MatVideoModule } from 'mat-video';
import { MatStepperModule } from '@angular/material/stepper';
import { ConditionsComponent } from './pages/conditions/conditions.component';
import { Step1Component } from './pages/contacts/steps/step1.component';
import { Step2Component } from './pages/contacts/steps/step2.component';
import { Step3Component } from './pages/contacts/steps/step3.component';
import { Step4Component } from './pages/contacts/steps/step4.component';
import { MAT_DATE_LOCALE } from '@angular/material';
import { AgmCoreModule } from '@agm/core';
import { SiteDownComponent } from './shared/components/site-down/site-down.component';



@NgModule({
  declarations: [
    AppComponent,
    UnderConstructionComponent,
    AboutComponent,
    PrivacyComponent,
    HomeComponent,
    PageNotFoundComponent,
    TranslatingPageComponent,
    SummaryComponent,
    WhereComponent,
    ContactsComponent,
    ConditionsComponent,
    Step1Component,
    Step2Component,
    Step3Component,
    SiteDownComponent,
    Step4Component
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialBasicModule,
    MaterialLayoutModule,
    FormsModule,
    MaterialFormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatCarouselModule.forRoot(),
    CarouselModule,
    MatVideoModule,
    MatStepperModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD8g7oJOXALl_5C6xRB7YZSf0Ovf-ZrDw4'
    })
  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy },
  { provide: MAT_DATE_LOCALE, useValue: 'it' },],
  bootstrap: [AppComponent],
  entryComponents: []
})
export class AppModule { }
